module.exports = __webpack_public_path__ + "img/sp02.c0c777da.svg";